import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PagamentoDespesaDetalharRoutingModule } from "./pagamento-despesa-detalhar-routing.module";
import { PagamentoDespesaDetalharComponent } from "./pagamento-despesa-detalhar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";



@NgModule({
    imports: [
        CommonModule,
        PagamentoDespesaDetalharRoutingModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        MessagesModule,
        ProgressSpinnerModule

    ],
    declarations: [PagamentoDespesaDetalharComponent]
})
export class PagamentoDespesaDetalharModule { }
